import { Component, OnInit,AfterViewInit, TemplateRef, Output, EventEmitter ,ViewChild, ElementRef} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ElasitcService } from '../../servies/elastic/elasitc.service';
import { environment } from '../../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router,ActivatedRoute } from '@angular/router';
declare var $: any;
import { NavbarModule, WavesModule, ButtonsModule } from 'angular-bootstrap-md';

import {UserService} from '../../servies/user/user.service';
import { NgZone } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud"; 
//import am4plugins_rangeSelector from "@amcharts/amcharts4/themes/rangeSelector";
import * as am4plugins_rangeSelector from "@amcharts/amcharts4/plugins/rangeSelector";
import {ExcelService} from '../../servies/export_xls/excel-export';
import {FacetsService} from '../../servies/Facets/facets.service'


import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';

import * as jsPDF from 'jspdf'; 
import { Options, LabelType, ChangeContext } from 'ng5-slider';
 
import html2canvas from 'html2canvas';
am4core.useTheme(am4themes_animated);
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})

export class SearchComponent implements OnInit,AfterViewInit {

 // @Output() sendvalue= new  EventEmitter<string>();  
 // @Output() public name: string;
 // @Output() public hitsall: any[];

 // @ViewChild('sp',{static:true}) sp;

//  start: any = 1547512616; // start time in milli Seconds
//   end: any = 15475126720;  // end time in milli Seconds
//   minValue: number = this.start;
//   maxValue: number = this.end;
//   options: Options = {
//     floor: this.start,
//     ceil: this.end,
//     step: 1000,
//     translate: (value: number, label: LabelType): string => {
//       return new Date(value).toTimeString(); // this will translate label to time stamp.
//     }
//   };

searchText:string="";
ChartData:any[]=[];
CRGData:any[]=[];
ClaimsChartData:any[]=[];
dateRange: number[] = this.createDateRange();
minValue: number = this.dateRange[0];
maxValue: number = this.dateRange[this.dateRange.length-1];
options: Options = {
  floor: this.dateRange[0],
  ceil: this.dateRange[this.dateRange.length-1],
  // stepsArray: this.dateRange.map((date: Date) => {
  //   return { value: date.getTime() };
  // }),
  translate: (value: number, label: LabelType): string => {
    switch (label) {
      case LabelType.Low:
      return value+"";
      case LabelType.High:
        return value+"";
      default:
      return value+"";
      // return new Date(value).toDateString();
    }
    
  }
};

createDateRange(): number[] {
  const dates: number[] = [];
  for (let i: number = 1990; i <= 2020; i++) {
    dates.push(i);
  }
  return dates;
}

datecreation(num:number){
let dates=new Date(num);
let res= (dates.getMonth() + 1) + 
    "/" +  dates.getDate() +
    "/" +  dates.getFullYear();
  return res;

}

 item :any;
 detailedViewContent:any;
  content:any;
  title:string="";
  isCollapsed = true;
  private chart: am4charts.XYChart;
  consolidatedView=true;
  modalRef: BsModalRef;
  myForm: FormGroup;
  totalHits: number = 0;
  currentPage = 1;
  viewmappings:any[]=[];
  facetmapings:any[]=[];
  displayFacets:any[]=[];
  indices: any[] = [];
  timeTook: number = 0;
  pages: any[] = [];
  pageSize: number = 10;
  pageSizeAll: number = 0;

  pageSizes: any[] = [10, 25, 50, 100];

  checkModel: any = { desc: true, asc: false };
  logged_in_username: string="";
  q: string = "";
  error: string = "";
  searchValue :string="";
  index: any = environment.defaultIndex;

  hitsFrom: number = 0;
  hitsTo: number = 0;
  excel_flag: number=0;
  sourcedisplaysettings:any
  total_pages: number = 0;
  hasResults: boolean = false;
  hits: any[] = [];
  CRGhits:any[]=[];
  Claimhits:any[]=[];
  consolidatedhits:any[]=[];
  suggestions: any[] = [];
  hits_export: any[] = [];
  excel_data : any[]=[];
  fields: any[] = [];
  
  facets: any[] = [];
  data: any[]=[];
  //var data: any[] = [];
  srcstr:string = "http://182.72.246.214:5601/app/kibana#/visualize/edit/120963d0-a4b2-11e9-b2d2-69a824d799ea?embed=true&_g=(filters:!())&_a=(filters:!(),linked:!f,query:(language:kuery,query:''),uiState:(vis:(legendOpen:!f)),vis:(aggs:!((enabled:!t,id:'2',params:(field:Major_Findings.keyword),schema:metric,type:cardinality),(enabled:!t,id:'3',params:(field:Audit_Location_Name.keyword,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'2',otherBucket:!f,otherBucketLabel:Other,size:5),schema:group,type:terms)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),grid:(categoryLines:!t,valueAxis:ValueAxis-1),legendPosition:bottom,orderBucketsBySum:!t,seriesParams:!((data:(id:'2',label:'Unique%20count%20of%20Major_Findings.keyword'),drawLinesBetweenPoints:!t,interpolate:step-after,mode:normal,show:!t,showCircles:!t,type:histogram,valueAxis:ValueAxis-1)),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Unique%20count%20of%20Major_Findings.keyword'),type:value))),title:'Location%20vs%20Major_Findings',type:histogram))";
  filters: any[] = [];
  allwords:string="";
  exactphrase:string="";
  anywords:string="";
  nonewords:string="";
  isadvancesearch:boolean = false;
  searchtype:string="";
  advancesearch: any[]=[];
  myadvancesearch: FormGroup;
  isexport:boolean=false;
  sorting:any[]=[];
  sortvalue:string="";
  sortname:string="";

  constructor(private datePipe: DatePipe,private elastic: ElasitcService, private activatedRoute:ActivatedRoute,private facetsservice: FacetsService , 
    private _facetserv:FacetsService,private formBuilder: FormBuilder, private modalService: BsModalService, private loadingBar: LoadingBarService, private zone: NgZone,private router: Router,private _userService: UserService,private _excelService:ExcelService, private spinnerService: Ng4LoadingSpinnerService) {            
    if(sessionStorage.getItem('loggedin')=='false' || sessionStorage.getItem('loggedin')==null)
    {      
      this.gotoLogin();
    }    
    else if(sessionStorage.getItem('loggedin')=='true'){
      this.logged_in_username= sessionStorage.getItem('loggedinname');
      //this.router.getCurrentNavigation().extras.state.logged_in_user;     
    }
   // this.name = 'swaroop';
   // this.hitsall=this.hits;
   }
  // test: string="Hi";
  onUserChangeEnd(changeContext: ChangeContext): void {
   console.log( (this.minValue) + " and " + (this.maxValue) );
  }

   limit: number=5;
   moreLess:number;
   getRssFeed()
   {    
    var data: any[] = [];  
     //console.log('In getRssFeed');
     //console.log(this.sendvalue.emit(this.test));
     //this.sendvalue.emit(this.test);     
     //this.router.navigate(['/rss-feed'], { queryParams: { hits: this.hits} });
       
     //this.hits_export=this.getHitsExcel();          
     //console.log(this.hits_export); 
     //this.router.navigate(['/rss-feed'], {state: {hits_export: this.hits_export}});
   }   

   clearSearch(){
    this.q="";
    this.advancesearch=[];
    this.allwords="";
    this.exactphrase="";
    this.anywords="";
    this.nonewords="";
    this.sortvalue="";
    this.myadvancesearch.get('daysyear').disable();
    this.myadvancesearch.get('advanceradio').setValue('anytime');
    this.myadvancesearch.get('lastno').setValue('');
    this.myadvancesearch.get('betweenfrom').setValue('');
    this.myadvancesearch.get('betweento').setValue('');    
    this.fnAnytime();    
    this.filters=[];   
    this.getHits("@all");
   }
   gotoLogin(){    
    this.router.navigate(['/login']);  // define your component where you want to go
  }
  changeview(){
    
    this.consolidatedView=!this.consolidatedView;
    this.pageSize=10;//this.consolidatedView?10:100;
    this.hasResults=false;
    if(this.q=="")
    {
       this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }  
  }
  startDateChange(){
    this.getHits(this.q);
  }
  ngAfterViewInit() {
   // console.log("result:", this.sp.nativeElement);
  //  $("#startDate").change(function(){
    
  //   //alert($("#startDate").val())
  //   this.getHits(this.q);
        
  //   });
    this.zone.runOutsideAngular(() => {
      
    });
    
    }

  
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }

  
   OpenUrl(hit:any)
  {  
    if(hit._source.Pdf!="Unknown" && hit._source.Pdf!="Not Applicable")
      window.open(hit._source.Pdf);
    else if(hit._source.URL!=undefined)
      window.open(hit._source.URL);       
    else if(hit._source.profile_link!=undefined)
    {
      window.open(hit._source.profile_link);
    }
    else if(hit._source.path!==undefined && hit._source.path!='/home/swaroop/csv/Claims.csv' )
    {                 
      if(hit._source.path.virtual==='/104101.ed_hd.mp4')
      {
        window.open("http://45.118.183.70:5501/videos/search/index.html");         
      }
      else
      {
        window.open("http://45.118.183.70:5501/" + hit._index + "/" + hit._source.path.virtual);   
      }
    }   
    else
    {
      this.consolidatedView==true?this.openQuickView(hit, false):this.openConsolidatedQuickView(hit,false);
    } 
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  __fieldsAsArray(properties: any, parent: string): any[] {
    var fields: any[] = [];
    for(var field in properties){
      if((["_score", "script"].indexOf(field) === -1) && properties.hasOwnProperty(field) && !properties[field].hasOwnProperty("properties")){
        fields.push({
          'name': (parent ? (parent+"."+field): field),
          'type': properties[field]['type']
        });
      } else{
        fields = fields.concat(this.__fieldsAsArray(properties[field].properties, field));
      }
    }
    return fields;
  }
  __fieldsAsArray_xls(properties: any, parent: string): any[] {
    var fields: any[] = [];
    for(var field in properties){
    if(properties[field]!=null)
      {
      if((["_score", "script"].indexOf(field) === -1) && properties.hasOwnProperty(field) && !properties[field].hasOwnProperty("properties")){
        fields.push({
          'name': (parent ? (parent+"."+field): field),
          'value': properties[field]
        });
      } else{
        fields = fields.concat(this.__fieldsAsArray(properties[field].properties, field));
      }
    }
    }
    return fields;
  }

  ngOnInit() { 
   
    this.activatedRoute.params.subscribe(params => {
      let id = params['id'];
    if(id!=undefined)
      {this.q=id;
        //this.searchText=id;
      }
      
    });   
    this._facetserv.getViewMappings().subscribe((viewmappings:any)=>{
      this.viewmappings=viewmappings
       //console.log(this.facetmapings);
     }); 
    this._facetserv.getFacetMappings().subscribe((facetmapings:any)=>{
      this.facetmapings=facetmapings
       //console.log(this.facetmapings);
     });
     this._facetserv.getshowHideFacets().subscribe((displayFacets:any)=>{
      this.displayFacets=displayFacets
     });      
    this.myForm = this.formBuilder.group({
      radio: 'desc'
    });  
    
    this.myadvancesearch = this.formBuilder.group({
      advanceradio:[''],
      lastno:[''],
      daysyear:['Days'],
      betweento:[''],
      betweenfrom:[''],
      
    }); 
    this.myadvancesearch.get('daysyear').disable();
    this.myadvancesearch.get('advanceradio').setValue('anytime');

    this.elastic.getIndicesWithFields().subscribe(data => {  
        this.indices.push(environment.defaultIndex);    
        for(var key in data){
          if(key.substring(0,1)!="."){
          if(data.hasOwnProperty(key) && environment.excludeIndices.indexOf(key) == -1){
            this.indices.push({
              'name': key,
              'title': key,
              'fields': environment.defaultIndex.fields.concat(this.__fieldsAsArray(data[key].mappings.properties, null))
            });
          }
        }
        }
        this.indices = this.indices.sort((a, b) => a.title.localeCompare(b.title)); 
        if(this.logged_in_username=="ixdemo@intuceo.com"){
          this.indices=this.indices.filter(x=>x.name=='covid-19_clinical_studies')
          var dropindex=this.indices.find(x=>x.name=='covid-19_clinical_studies')
            this.selectOption(dropindex)
        }   
        else{      
          if(this.router.url.search("claims")>-1)
          {
            var dropindex=this.indices.find(x=>x.name=='claims')
            this.selectOption(dropindex) 
          }
          else{
          var dropindex=this.indices.find(x=>x.name=='medical_records')
            this.selectOption(dropindex) 
          } 
        }
      },
      error => {
        console.log(error);
        this.error = error.message;
      },
      () => {
        // No errors, route to new page
        if(this.q=="")
        {
          this.getHits("@all");
        }
        else
        {
          this.getHits(this.q);
        }
      }
    )
    this.sortvalue="_score";
    this.sortname="Score";
    this.fnSortlist();
    
    
  }

  showMore(id) {   
    this.moreLess=id;
    var showMore = <HTMLFormElement>document.getElementById('showMore'+id);
    showMore.style.display='none';
    var showMore = <HTMLFormElement>document.getElementById('showLess'+id);
    showMore.style.display='block';
    this.limit = 10;
   };

   showLess(id) {
    this.moreLess=id;
    var showLess = <HTMLFormElement>document.getElementById('showLess'+id);
    showLess.style.display='none';
    var showLess = <HTMLFormElement>document.getElementById('showMore'+id);
    showLess.style.display='block';    
    this.limit = 5;      
   };

  reset(): void{
    this.error = null;
    this.hits = [];
    this.totalHits = 0;
    // this.hasResults = false;
    this.hitsFrom = 0;
    this.hitsTo = 0;
  }
EncounterBarchart(){
  
    let chart = am4core.create("encounterbar", am4charts.XYChart);
          
         
          if(this.facets.find(x=> x.name == 'encounters_desc')!=undefined)      
            chart.data = this.facets.find(x=> x.name == "encounters_desc")!=null?this.facets.find(x=> x.name == "encounters_desc").details:null;        
          // Create axes
          var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis.dataFields.category = "key";
          categoryAxis.renderer.grid.template.location = 0;
          categoryAxis.renderer.minGridDistance = 30;
          categoryAxis.renderer.labels.template.horizontalCenter = "right";
          categoryAxis.renderer.labels.template.verticalCenter = "middle";
          categoryAxis.renderer.labels.template.rotation = 270;
          categoryAxis.tooltip.disabled = true;
          categoryAxis.renderer.minHeight = 110;
  
          var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.renderer.minWidth = 50;
          
          // Create series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.sequencedInterpolation = true;
          series.dataFields.valueY = "doc_count";
          series.dataFields.categoryX = "key";
          series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
          series.columns.template.strokeWidth = 0;
  
          series.tooltip.pointerOrientation = "vertical";
  
          series.columns.template.column.cornerRadiusTopLeft = 10;
          series.columns.template.column.cornerRadiusTopRight = 10;
          series.columns.template.column.fillOpacity = 0.8;
  
          // on hover, make corner radiuses bigger
          var hoverState = series.columns.template.column.states.create("hover");
          hoverState.properties.cornerRadiusTopLeft = 0;
          hoverState.properties.cornerRadiusTopRight = 0;
          hoverState.properties.fillOpacity = 1;
  
          series.columns.template.adapter.add("fill", function(fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
          });
  
          // Cursor
          chart.cursor = new am4charts.XYCursor();
  
          this.chart = chart;
 
}
StudiesPIEChatr(){
  let countychart = am4core.create("studiespie", am4charts.PieChart);
  //countychart.paddingLeft = 40;              
  // let countytitle= countychart.titles.create();
  // countytitle.text="";
  // countytitle.fontSize = 18;
  // countytitle.fontWeight="bold";
  // //countytitle.marginBottom=15;
  // countytitle.horizontalCenter="middle"; 
  var facets= this.numbersort(this.facets.find(x=> x.name == "Phases").details)  ; 
    countychart.data = facets
  // if(this.facets.find(x=> x.name == 'Phases')!=undefined)      
  // countychart.data =this.facets.find(x=> x.name == "Phases")!=null? this.facets.find(x=> x.name == "Phases").details:null; 
  // console.log(countychart.data);               
          // Add and configure Series
  var pieSeries = countychart.series.push(new am4charts.PieSeries());
  pieSeries.dataFields.value = "doc_count";
  pieSeries.dataFields.category = "key";      
  // Let's cut a hole in our Pie chart the size of 30% the radius
  countychart.innerRadius = am4core.percent(0);

  // Put a thick white border around each Slice
  pieSeries.slices.template.stroke = am4core.color("#fff");
  pieSeries.slices.template.strokeWidth = 2;
  pieSeries.slices.template.strokeOpacity = 1;
  pieSeries.slices.template
    // change the cursor on hover to make it apparent the object can be interacted with
    .cursorOverStyle = [
      {
        "property": "cursor",
        "value": "pointer"
      }
    ];

/*      pieSeries.alignLabels = false;
  pieSeries.labels.template.bent = true;
  pieSeries.labels.template.radius = 3;
  pieSeries.labels.template.padding(0,0,0,0); */        
  pieSeries.ticks.template.disabled = true;
  pieSeries.alignLabels = false;
  //pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";        
  pieSeries.labels.template.text = "{key}";           
  pieSeries.labels.template.radius = am4core.percent(-60);
  pieSeries.labels.template.fill = am4core.color("white");
  pieSeries.labels.template.relativeRotation = 90;
  pieSeries.labels.template.fontSize=10;       

  // Create a base filter effect (as if it's not there) for the hover to return to
  var shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
  shadow.opacity = 0;

  // Create hover state
  var countyhoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

  // Slightly shift the shadow and make it more prominent on hover
  var hoverShadow = countyhoverState.filters.push(new am4core.DropShadowFilter);
  hoverShadow.opacity = 0.7;
  hoverShadow.blur = 5;

  pieSeries.slices.template.events.on("hit", function(ev) {
    var name=ev.target.dataItem.properties.category;
    
    //$("#Intervention_Type_"+name).click()
    this.onFilterOptionClick(true,"Phases","Phases",name);
  }, this);

  // Add a legend
  //chart.legend = new am4charts.Legend();

  // Create axes
  /* var categoryAxis = countychart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.dataFields.category = "key";
  categoryAxis.renderer.grid.template.location = 0;
  categoryAxis.renderer.minGridDistance = 30;
  categoryAxis.renderer.labels.template.horizontalCenter = "right";
  categoryAxis.renderer.labels.template.verticalCenter = "middle";
  categoryAxis.renderer.labels.template.rotation = 270;
  categoryAxis.tooltip.disabled = true;
  categoryAxis.renderer.minHeight = 110;

  var valueAxis = countychart.yAxes.push(new am4charts.ValueAxis());
  valueAxis.renderer.minWidth = 50;
  
  // Create series
  var series = countychart.series.push(new am4charts.ColumnSeries());
  series.sequencedInterpolation = true;
  series.dataFields.valueY = "doc_count";
  series.dataFields.categoryX = "key";
  series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
  series.columns.template.strokeWidth = 0;

  series.tooltip.pointerOrientation = "vertical";

  series.columns.template.column.cornerRadiusTopLeft = 10;
  series.columns.template.column.cornerRadiusTopRight = 10;
  series.columns.template.column.fillOpacity = 0.8;

  // on hover, make corner radiuses bigger
  var hoverState = series.columns.template.column.states.create("hover");
  hoverState.properties.cornerRadiusTopLeft = 0;
  hoverState.properties.cornerRadiusTopRight = 0;
  hoverState.properties.fillOpacity = 1;

  series.columns.template.adapter.add("fill", function(fill, target) {
    return countychart.colors.getIndex(target.dataItem.index);
  });

  // Cursor
  countychart.cursor = new am4charts.XYCursor();

  this.chart = countychart;

  */
};
BellCurve(){
  let chart = am4core.create("chartdiv", am4charts.XYChart);
chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

// Title
let title = chart.titles.create();
title.text = "Region";
title.fontSize = 20;
title.marginBottom = 20;

// Set format
//chart.numberFormatter.numberFormat = "'[font-size: 5]US$[/] [bold]'#.0B";

// Create axes
let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.labels.template.disabled = true;
categoryAxis.dataFields.category = "category";

let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
if(this.facets.find(x=> x.name == 'Region')!=undefined)  {   
chart.data = this.facets.find(x=> x.name == "Region")!=null?this.facets.find(x=> x.name == "Region").details:null;        
chart.data.push({"key":"category","doc_count":""})
}// Set data
console.log(chart.data)
// chart.data = [{
//   "category": "",
//   "Walmart": 387.66,
//   "Amazon.com": 120.93,
//   "The Kroger Co.": 119.70,
//   "Costco": 101.43,
//   "Walgreens Boots Alliance": 98.39,
//   "The Home Depot": 97.27,
//   "CVS Health Corporation": 83.79,
//   "Target": 74.48,
//   "Lowe's Companies": 64.09,
//   "Albertsons Companies": 59.71
// }];

// Series
//let data = chart.data[0];
chart.data.forEach(function (value) {
  if (value.key != "category") {
    var series = chart.series.push(new am4charts.CurvedColumnSeries());
   series.dataFields.categoryX = "category";
   series.dataFields.valueY = value;
   series.name = value;
   series.tooltipText = "{name}: {valueY.doc_count}";
   series.columns.template.strokeWidth = 2;
   series.columns.template.strokeOpacity = 1;
   series.columns.template.fillOpacity = 0;
   series.columns.template.width = am4core.percent(100);
   series.clustered = false;
 }
}); 


// Cursor
chart.cursor = new am4charts.XYCursor();
chart.cursor.maxTooltipDistance = 10;

// Legend
// chart.legend = new am4charts.Legend();
// chart.legend.fontSize = 12;
// chart.legend.position = "right";
// chart.legend.valign = "top";
// chart.legend.marginTop = 0;
// chart.legend.labels.template.width = 130;
// chart.legend.labels.template.truncate = true;
// chart.legend.valueLabels.template.text = "{valueY.close}"
// chart.legend.valueLabels.template.fontSize = 12;
}
StudiesBarOutside(){
  am4core.useTheme(am4themes_animated);
// Themes end

var chart = am4core.create("chartdiv", am4charts.XYChart);
chart.padding(40, 40, 40, 40);

chart.paddingRight = 20;
        let title= chart.titles.create();
        title.text="Region";
        title.fontSize = 18;
        title.fontWeight="bold";
        title.marginBottom=15;
        title.horizontalCenter="middle";
var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.dataFields.category = "key";
categoryAxis.renderer.minGridDistance = 1;
categoryAxis.renderer.inversed = true;
categoryAxis.renderer.grid.template.disabled = true;

var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
valueAxis.min = 0;

var series = chart.series.push(new am4charts.ColumnSeries());
series.dataFields.categoryY = "key";
series.dataFields.valueX = "doc_count";
series.tooltipText = "{valueX.value}"
series.columns.template.strokeOpacity = 0;
series.columns.template.column.cornerRadiusBottomRight = 5;
series.columns.template.column.cornerRadiusTopRight = 5;

var labelBullet = series.bullets.push(new am4charts.LabelBullet())
labelBullet.label.horizontalCenter = "left";
labelBullet.label.dx = 5;
labelBullet.label.text = "{values.valueX.workingValue.formatNumber('#.0as')}";
labelBullet.locationX = 1;

// as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
series.columns.template.adapter.add("fill", function(fill, target){
  return chart.colors.getIndex(target.dataItem.index);
});

categoryAxis.sortBySeries = series;
if(this.facets.find(x=> x.name == 'Region')!=undefined)      
          chart.data = this.facets.find(x=> x.name == "Region")!=null?this.facets.find(x=> x.name == "Region").details:null;        
}
StudiesCountryBarchart(id){
  
  let chart = am4core.create(id, am4charts.XYChart);
        
  var facets= this.numbersort(this.facets.find(x=> x.name == "Country").details)  ; 
  chart.data = facets
        // if(this.facets.find(x=> x.name == 'Country')!=undefined)      
        //   chart.data = this.facets.find(x=> x.name == "Country")!=null?this.facets.find(x=> x.name == "Country").details:null;        
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "key";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "doc_count";
        series.dataFields.categoryX = "key";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });
        series.columns.template.events.on("hit", function(ev) {
          var name=ev.target.dataItem.categories.categoryX;
          ///$("#Region_"+name).click()
          this.onFilterOptionClick(true,"Country","Country",name);
          
        }, this);  
        // Cursor
        chart.cursor = new am4charts.XYCursor();

        this.chart = chart;

}
StudiesBarchart(id){
  
  let chart = am4core.create(id, am4charts.XYChart);
        
  let title= chart.titles.create();
  title.text="Region";
  title.fontSize = 18;
  title.fontWeight="bold";
  title.marginBottom=15;
  title.horizontalCenter="middle";
        //if(this.facets.find(x=> x.name == 'Region')!=undefined)  
        var facets= this.numbersort(this.facets.find(x=> x.name == "Region").details)  ; 
          chart.data = facets //.find(x=> x.name == "Region")!=null?this.facets.find(x=> x.name == "Region").details:null;        
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "key";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;
        categoryAxis.renderer.labels.template.fontSize = 10;
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.labels.template.fontSize = 15;
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "doc_count";
        series.dataFields.categoryX = "key";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });
        series.columns.template.events.on("hit", function(ev) {
          var name=ev.target.dataItem.categories.categoryX;         
          this.onFilterOptionClick(true,"Region","Region",name);          
        }, this);  
        // Cursor
        chart.cursor = new am4charts.XYCursor();

        this.chart = chart;
       
}

FunnelChart(){
  let Funnelchart = am4core.create("Funneldiv", am4charts.SlicedChart);
  Funnelchart.hiddenState.properties.opacity = 0; 
if(this.facets.find(x=> x.name == 'conditions_desc')!=undefined)   
Funnelchart.data=this.facets.find(x=> x.name == "conditions_desc")!=null? this.facets.find(x=> x.name == "conditions_desc").details:null;
let series = Funnelchart.series.push(new am4charts.FunnelSeries());
series.colors.step = 2;
series.dataFields.value = "doc_count";
series.dataFields.category = "key";
series.alignLabels = true;

series.labelsContainer.paddingLeft = 15;
series.labelsContainer.width = 200;

//series.orientation = "horizontal";
//series.bottomRatio = 1;

Funnelchart.legend = new am4charts.Legend();
Funnelchart.legend.position = "left";
Funnelchart.legend.valign = "bottom";
Funnelchart.legend.margin(5,5,20,5);
}  
ParetoChart(){
    let paretochart = am4core.create("paretodiv", am4charts.XYChart);
    paretochart.scrollbarX = new am4core.Scrollbar();
    if(this.facets.find(x=> x.name == 'immunizations_description')!=undefined)  
      paretochart.data = this.facets.find(x=> x.name == "immunizations_description")!=null?this.facets.find(x=> x.name == "immunizations_description").details:null;
           
    prepareParetoData();

function prepareParetoData(){
    let total = 0;

    for(var i = 0; i < paretochart.data.length; i++){
        let value = paretochart.data[i].doc_count;
        total += value;
    }

    let sum = 0;
    for(var i = 0; i < paretochart.data.length; i++){
        let value = paretochart.data[i].doc_count;
        sum += value;   
        paretochart.data[i].pareto = sum / total * 100;
    }    
}

// Create axes
let categoryAxis = paretochart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "key";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

let valueAxis = paretochart.yAxes.push(new am4charts.ValueAxis());
valueAxis.renderer.minWidth = 50;
valueAxis.min = 0;
valueAxis.cursorTooltipEnabled = false;

// Create series
let series = paretochart.series.push(new am4charts.ColumnSeries());
series.sequencedInterpolation = true;
series.dataFields.valueY = "doc_count";
series.dataFields.categoryX = "key";
series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
series.columns.template.strokeWidth = 0;

series.tooltip.pointerOrientation = "vertical";

series.columns.template.column.cornerRadiusTopLeft = 10;
series.columns.template.column.cornerRadiusTopRight = 10;
series.columns.template.column.fillOpacity = 0.8;

// on hover, make corner radiuses bigger
let hoverState = series.columns.template.column.states.create("hover");
hoverState.properties.cornerRadiusTopLeft = 0;
hoverState.properties.cornerRadiusTopRight = 0;
hoverState.properties.fillOpacity = 1;

series.columns.template.adapter.add("fill", function(fill, target) {
  return paretochart.colors.getIndex(target.dataItem.index);
})


let paretoValueAxis = paretochart.yAxes.push(new am4charts.ValueAxis());
paretoValueAxis.renderer.opposite = true;
paretoValueAxis.min = 0;
paretoValueAxis.max = 100;
paretoValueAxis.strictMinMax = true;
paretoValueAxis.renderer.grid.template.disabled = true;
paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
paretoValueAxis.numberFormatter.numberFormat = "#'%'"
paretoValueAxis.cursorTooltipEnabled = false;

let paretoSeries = paretochart.series.push(new am4charts.LineSeries())
paretoSeries.dataFields.valueY = "pareto";
paretoSeries.dataFields.categoryX = "key";
paretoSeries.yAxis = paretoValueAxis;
paretoSeries.tooltipText = "cumulative: {valueY.formatNumber('#.0')}%[/]";
paretoSeries.bullets.push(new am4charts.CircleBullet());
paretoSeries.strokeWidth = 2;
paretoSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
paretoSeries.strokeOpacity = 0.5;

// Cursor
paretochart.cursor = new am4charts.XYCursor();
paretochart.cursor.behavior = "panX";
  }
  DumbbellPlot(){
    let dumbbelchart = am4core.create("Radordiv", am4charts.XYChart);
    let open = 100;
    let actdata=[];
    let close = 120;
    if(this.facets.find(x=> x.name == 'medications_desc')!=undefined){    
     var data = this.facets.find(x=> x.name == "medications_desc")!=null?this.facets.find(x=> x.name == "medications_desc").details:null; 
     for (var i = 0; i < data.length; i++) {
      actdata.push({ key: data[i].key, open: 15000, close: data[i].doc_count });
     }
     dumbbelchart.data=actdata;
     console.log(actdata)
    }
    let categoryAxis = dumbbelchart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.dataFields.category = "key";
categoryAxis.renderer.minGridDistance = 15;
categoryAxis.renderer.grid.template.location = 0.5;
categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
categoryAxis.renderer.labels.template.rotation = -90;
categoryAxis.renderer.labels.template.horizontalCenter = "left";
categoryAxis.renderer.labels.template.location = 0.5;
categoryAxis.renderer.inside = true;

categoryAxis.renderer.labels.template.adapter.add("dx", function(dx, target) {
    return -target.maxRight / 2;
})

let valueAxis = dumbbelchart.yAxes.push(new am4charts.ValueAxis());
valueAxis.tooltip.disabled = true;
valueAxis.renderer.ticks.template.disabled = true;
valueAxis.renderer.axisFills.template.disabled = true;

let series = dumbbelchart.series.push(new am4charts.ColumnSeries());
series.dataFields.categoryX = "key";
series.dataFields.openValueY = "open";
series.dataFields.valueY = "close";
series.tooltipText = "open: {openValueY.value} close: {valueY.value}";
series.sequencedInterpolation = true;
series.fillOpacity = 0;
series.strokeOpacity = 1;
series.columns.template.width = 0.01;
series.tooltip.pointerOrientation = "horizontal";

let openBullet = series.bullets.create(am4charts.CircleBullet);
//openBullet.locationY = 1;

let closeBullet = series.bullets.create(am4charts.CircleBullet);

closeBullet.fill = dumbbelchart.colors.getIndex(4);
closeBullet.stroke = closeBullet.fill;

dumbbelchart.cursor = new am4charts.XYCursor();

dumbbelchart.scrollbarX = new am4core.Scrollbar();
dumbbelchart.scrollbarY = new am4core.Scrollbar();

  }
  pyramid(){
    let pyramidchart = am4core.create("stackchart", am4charts.SlicedChart);
    let countytitle= pyramidchart.titles.create();
        countytitle.text="County";
        countytitle.fontSize = 18;
        countytitle.fontWeight="bold";
        countytitle.marginBottom=15;
        countytitle.horizontalCenter="middle";    
    if(this.facets.find(x=> x.name == 'county')!=undefined)     
    pyramidchart.data =this.facets.find(x=> x.name == "county")!=null? this.facets.find(x=> x.name == "county").details:null; 
    let series = pyramidchart.series.push(new am4charts.PyramidSeries());
    series.dataFields.value = "doc_count";
    series.dataFields.category = "key";
    series.alignLabels = true;
    series.valueIs = "height";
    series.alignLabels = true;
      series.labelsContainer.width=150;
      series.labelsContainer.paddingLeft = 15;
      
      series.labelsContainer.fontSize=10;
  }
  CRGLayeredChart(){
    let CRGLayeredchart = am4core.create("CRG", am4charts.XYChart);
    CRGLayeredchart.data=this.CRGData;
    let categoryAxis = CRGLayeredchart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "CRG";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.minGridDistance = 30;

        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

let valueAxis = CRGLayeredchart.yAxes.push(new am4charts.ValueAxis());
valueAxis.title.text = "Paid Amount Institutional vs Paid Amount Professional By CRG";
//valueAxis.title.fontWeight = 800;

// Create series
let series = CRGLayeredchart.series.push(new am4charts.ColumnSeries());
series.dataFields.valueY = "Institutional";
series.dataFields.categoryX = "CRG";
series.clustered = false;
series.tooltipText = "Paid Amount Institutional for {categoryX} : [bold]{valueY}[/]";

let series2 = CRGLayeredchart.series.push(new am4charts.ColumnSeries());
series2.dataFields.valueY = "Professional";
series2.dataFields.categoryX = "CRG";
series2.clustered = false;
series2.columns.template.width = am4core.percent(50);
series2.tooltipText = "Paid Amount Professional for {categoryX}: [bold]{valueY}[/]";

CRGLayeredchart.cursor = new am4charts.XYCursor();
CRGLayeredchart.cursor.lineX.disabled = true;
CRGLayeredchart.cursor.lineY.disabled = true;
 
  }
  ClaimsLayeredChart(){
    let claimsLayeredchart = am4core.create("person", am4charts.XYChart);
    claimsLayeredchart.data=this.ClaimsChartData;
    let categoryAxis = claimsLayeredchart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "person";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.minGridDistance = 30;

        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

let valueAxis = claimsLayeredchart.yAxes.push(new am4charts.ValueAxis());
valueAxis.title.text = "Paid Amount Institutional vs Paid Amount Professional By Person";
//valueAxis.title.fontWeight = 800;

// Create series
let series = claimsLayeredchart.series.push(new am4charts.ColumnSeries());
series.dataFields.valueY = "Institutional";
series.dataFields.categoryX = "person";
series.clustered = false;
series.tooltipText = "Paid Amount Institutional for {categoryX} : [bold]{valueY}[/]";

let series2 = claimsLayeredchart.series.push(new am4charts.ColumnSeries());
series2.dataFields.valueY = "Professional";
series2.dataFields.categoryX = "person";
series2.clustered = false;
series2.columns.template.width = am4core.percent(50);
series2.tooltipText = "Paid Amount Professional for {categoryX}: [bold]{valueY}[/]";

claimsLayeredchart.cursor = new am4charts.XYCursor();
claimsLayeredchart.cursor.lineX.disabled = true;
claimsLayeredchart.cursor.lineY.disabled = true;
 
  }
  LayerdChart(){
    let Layeredchart = am4core.create("Layered", am4charts.XYChart);
    Layeredchart.data=this.ChartData;
    let categoryAxis = Layeredchart.xAxes.push(new am4charts.CategoryAxis());
categoryAxis.dataFields.category = "person";
categoryAxis.renderer.grid.template.location = 0;
categoryAxis.renderer.minGridDistance = 30;

        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

let valueAxis = Layeredchart.yAxes.push(new am4charts.ValueAxis());
valueAxis.title.text = "Total and UnCovered Amount";
//valueAxis.title.fontWeight = 800;

// Create series
let series = Layeredchart.series.push(new am4charts.ColumnSeries());
series.dataFields.valueY = "CoveredAmount";
series.dataFields.categoryX = "person";
series.clustered = false;
series.tooltipText = "Total Amount for {categoryX} : [bold]{valueY}[/]";

let series2 = Layeredchart.series.push(new am4charts.ColumnSeries());
series2.dataFields.valueY = "UnCoveredAmount";
series2.dataFields.categoryX = "person";
series2.clustered = false;
series2.columns.template.width = am4core.percent(50);
series2.tooltipText = "UnCoveredAmount for {categoryX}: [bold]{valueY}[/]";

Layeredchart.cursor = new am4charts.XYCursor();
Layeredchart.cursor.lineX.disabled = true;
Layeredchart.cursor.lineY.disabled = true;
  }
  StatusChart(){
    let pyramidchart = am4core.create("stackchart", am4charts.SlicedChart);
    let countytitle= pyramidchart.titles.create();
        countytitle.text="Status";
        countytitle.fontSize = 18;
        countytitle.fontWeight="bold";
        countytitle.marginBottom=15;
        countytitle.horizontalCenter="middle";  
        var facets=this.numbersort(this.facets.find(x=> x.name == "Status").details)
        console.log(facets) 
    
    pyramidchart.data =facets;
    let series = pyramidchart.series.push(new am4charts.PyramidSeries());
    series.dataFields.value = "doc_count";
    series.dataFields.category = "key";
    series.alignLabels = true;
    series.valueIs = "height";
    series.alignLabels = true;
      series.labelsContainer.width=150;
      series.labelsContainer.paddingLeft = 15;
      
      series.labelsContainer.fontSize=10;
      series.slices.template.events.on("hit", function(ev) {
        var name=ev.target.dataItem.properties.category;
       
        //$("#Status_"+name).click()
        this.onFilterOptionClick(true,"Status","Status",name);
        
      }, this); 
  }
  StatusChart1(){
    am4core.useTheme(am4themes_animated);
// Themes end

// Create chart instance
let chart = am4core.create("stackchart", am4charts.PieChart);
let countytitle= chart.titles.create();
              countytitle.text="Status";
              countytitle.fontSize = 18;
              countytitle.fontWeight="bold";

if(this.facets.find(x=> x.name == 'Status')!=undefined)      
          chart.data =this.facets.find(x=> x.name == "Status")!=null? this.facets.find(x=> x.name == "Status").details:null;     

// Set inner radius
chart.innerRadius = am4core.percent(50);

// Add and configure Series
let pieSeries = chart.series.push(new am4charts.PieSeries());
pieSeries.dataFields.value = "doc_count";
pieSeries.dataFields.category = "key";
pieSeries.slices.template.stroke = am4core.color("#fff");
pieSeries.slices.template.strokeWidth = 2;
pieSeries.slices.template.strokeOpacity = 1;
pieSeries.ticks.template.disabled = true;
pieSeries.alignLabels = false;
pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
//pieSeries.labels.template.radius = am4core.percent(-10);
pieSeries.labels.template.fill = am4core.color("white");
// This creates initial animation
pieSeries.hiddenState.properties.opacity = 1;
pieSeries.hiddenState.properties.endAngle = -90;
pieSeries.hiddenState.properties.startAngle = -90;


  }
  InterventionChart(){
    let Funnelchart = am4core.create("countychartdiv", am4charts.SlicedChart);
        Funnelchart.hiddenState.properties.opacity = 0;
        let countytitle= Funnelchart.titles.create();
              countytitle.text="Interventions";
              countytitle.fontSize = 18;
              countytitle.fontWeight="bold";
              countytitle.marginBottom=15;
              countytitle.horizontalCenter="middle"; 
              var facets=this.numbersort(this.facets.find(x=> x.name == "Intervention_Type").details) ;
      //if(this.facets.find(x=> x.name == 'Intervention_Type')!=undefined)   
      Funnelchart.data=facets;//this.facets.find(x=> x.name == "Intervention_Type")!=null? this.facets.find(x=> x.name == "Intervention_Type").details:null;
      let series = Funnelchart.series.push(new am4charts.FunnelSeries());
      series.colors.step = 2;
      series.dataFields.value = "doc_count";
      series.dataFields.category = "key";
      series.alignLabels = true;
      series.labelsContainer.width=150;
      //series.labelsContainer.paddingLeft = 15;
      
      series.labelsContainer.fontSize=8;

      series.slices.template.events.on("hit", function(ev) {
        var name=ev.target.dataItem.properties.category;
        
        //$("#Intervention_Type_"+name).click()
        this.onFilterOptionClick(true,"Intervention_Type","Intervention_Type",name);
      }, this);
  
  }
showChart1() {
  let chart = am4core.create("chartdiv", am4charts.XYChart);
        chart.paddingRight = 20;
        let title= chart.titles.create();
        title.text="Race";
        title.fontSize = 18;
        title.fontWeight="bold";
        title.marginBottom=15;
        title.horizontalCenter="middle";

        if(this.facets.find(x=> x.name == 'race')!=undefined)      
          chart.data =this.facets.find(x=> x.name == "race")!=null? this.facets.find(x=> x.name == "race").details:null;        
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "key";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "doc_count";
        series.dataFields.categoryX = "key";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();

        this.chart = chart;
};


showChart2(){
        let countychart = am4core.create("countychartdiv", am4charts.PieChart);
        //countychart.paddingLeft = 40;              
        let countytitle= countychart.titles.create();
        countytitle.text="Conditions";
        countytitle.fontSize = 18;
        countytitle.fontWeight="bold";
        //countytitle.marginBottom=15;
        countytitle.horizontalCenter="middle"; 
        if(this.facets.find(x=> x.name == 'conditions_desc')!=undefined)      
        countychart.data =this.facets.find(x=> x.name == "conditions_desc")!=null? this.facets.find(x=> x.name == "conditions_desc").details:null; 
        console.log(countychart.data);               
                // Add and configure Series
        var pieSeries = countychart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "doc_count";
        pieSeries.dataFields.category = "key";      
        // Let's cut a hole in our Pie chart the size of 30% the radius
        countychart.innerRadius = am4core.percent(0);

        // Put a thick white border around each Slice
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.slices.template
          // change the cursor on hover to make it apparent the object can be interacted with
          .cursorOverStyle = [
            {
              "property": "cursor",
              "value": "pointer"
            }
          ];

      /*      pieSeries.alignLabels = false;
        pieSeries.labels.template.bent = true;
        pieSeries.labels.template.radius = 3;
        pieSeries.labels.template.padding(0,0,0,0); */        
        pieSeries.ticks.template.disabled = true;
        pieSeries.alignLabels = false;
        //pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";        
        pieSeries.labels.template.text = "{value}";           
        pieSeries.labels.template.radius = am4core.percent(-60);
        pieSeries.labels.template.fill = am4core.color("white");
        pieSeries.labels.template.relativeRotation = 90;
        pieSeries.labels.template.fontSize=10;       

        // Create a base filter effect (as if it's not there) for the hover to return to
        var shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
        shadow.opacity = 0;

        // Create hover state
        var countyhoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

        // Slightly shift the shadow and make it more prominent on hover
        var hoverShadow = countyhoverState.filters.push(new am4core.DropShadowFilter);
        hoverShadow.opacity = 0.7;
        hoverShadow.blur = 5;

        // Add a legend
        //chart.legend = new am4charts.Legend();

        // Create axes
        /* var categoryAxis = countychart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "key";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = countychart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        
        // Create series
        var series = countychart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "doc_count";
        series.dataFields.categoryX = "key";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return countychart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        countychart.cursor = new am4charts.XYCursor();

        this.chart = countychart;

        */
      };
      showChart3(){        
        let encounterchart = am4core.create("encounterchartdiv", am4plugins_wordCloud.WordCloud);
        let encouseries = encounterchart.series.push(new am4plugins_wordCloud.WordCloudSeries());
       // encounterchart.fontFamily = "Courier New";
       encounterchart.paddingBottom = 20;
        var series = encounterchart.series.push(new am4plugins_wordCloud.WordCloudSeries());
        series.randomness = 0.1;
        series.rotationThreshold = 0.5;
        series.minFontSize=10;
        series.maxFontSize=20;
        series.fontWeight="bold";
        if(this.facets.find(x=> x.name == 'encounters_desc')!=undefined)      
        series.data = this.facets.find(x=> x.name == "encounters_desc")!=null?this.facets.find(x=> x.name == "encounters_desc").details:null;

        series.dataFields.word = "key";
        series.dataFields.value = "doc_count";

        series.heatRules.push({
        "target": series.labels.template,
        "property": "fill",
        "min": am4core.color("#0000CC"),
        "max": am4core.color("#CC00CC"),
        "dataField": "value"
        });

        //series.labels.template.url = "{word}";
        series.labels.template.urlTarget = "_blank";
        series.labels.template.tooltipText = "{word}: {value}";

        var hoverState = series.labels.template.states.create("hover");
        hoverState.properties.fill = am4core.color("#FF0000");

        //var subtitle =encounterchart.titles.create();
        //subtitle.text = "(click to open)";

        var title = encounterchart.titles.create();
        title.text = "Encounter";
        title.fontSize = 20;
        title.fontWeight = "800";

       
      };
      FunnelConditions(){
        let Funnelchart = am4core.create("countychartdiv", am4charts.SlicedChart);
        Funnelchart.hiddenState.properties.opacity = 0;
        let countytitle= Funnelchart.titles.create();
              countytitle.text="Conditions";
              countytitle.fontSize = 18;
              countytitle.fontWeight="bold";
              countytitle.marginBottom=15;
              countytitle.horizontalCenter="middle"; 
      if(this.facets.find(x=> x.name == 'conditions_desc')!=undefined)   
      Funnelchart.data=this.facets.find(x=> x.name == "conditions_desc")!=null? this.facets.find(x=> x.name == "conditions_desc").details:null;
      let series = Funnelchart.series.push(new am4charts.FunnelSeries());
      series.colors.step = 2;
      series.dataFields.value = "doc_count";
      series.dataFields.category = "key";
      series.alignLabels = true;
      series.labelsContainer.width=150;
      //series.labelsContainer.paddingLeft = 15;
      
      series.labelsContainer.fontSize=8;
      //series.labelsContainer.hide();
      //series.orientation = "horizontal";
      //series.bottomRatio = 1;
      
      // Funnelchart.legend = new am4charts.Legend();
      // Funnelchart.legend.position = "bottom";
      // Funnelchart.legend.valign = "bottom";
      // Funnelchart.legend.fontSize="10";
      // Funnelchart.legend.margin(5,5,20,5);
      }
      DateChart()
      {
        am4core.useTheme(am4themes_animated);

        var chart = am4core.create("Datechartdiv", am4charts.XYChart);
        chart.paddingRight = 20;

        var data = [];
        var visits = 10;
        for (var i = 1; i < 50000; i++) {
          visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
          data.push({ date: new Date(2018, 0, i), value: visits });
        }

        chart.data = data;

        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.minZoomCount = 5;


        // this makes the data to be grouped
        dateAxis.groupData = true;
        dateAxis.groupCount = 500;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        var series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "start_year";
        series.dataFields.valueY = "total_claim_cost ";
        series.tooltipText = "{valueY}";
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.background.fillOpacity = 0.5;

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;

        var scrollbarX = new am4core.Scrollbar();
        scrollbarX.marginBottom = 10;
        chart.scrollbarX = scrollbarX;

        // Add range selector
        var selector = new am4plugins_rangeSelector.DateAxisRangeSelector();
        selector.container = document.getElementById("Datechartdiv");
        selector.axis = dateAxis;
      }
getHits(keywords: string){  
  this.spinnerService.show();
   if(this.consolidatedView && this.index.name=="medical_records")
    this.pageSize=3000; 
  else
  this.pageSize=this.pageSize==3000?10:this.pageSize;
    this.error = null;        
    if(this.index.name=='')
      { 
        this.fields=[];      
        for(var indice of this.indices){
          if(indice.fields.length>1)
          {
            var fields=this.indices.find(i => i.name ==indice.name).fields;
            this.fields=this.fields.concat(fields)
          }
        } 
        //this.fields = this.indices.find(i => i.name == "medical_records" && i.name=="claims" && i.name=="videos").fields;
        //console.log(this.indices)
      }
      else{
        this.fields = this.indices.find(i => i.name == this.index.name).fields;  
      }  
      // if(this.index.name=="sampledateindex"){
      // var startdate=new Date($("#startDate").val());
      // var date=this.datePipe.transform(startdate, 'yyyy-MM-dd');
      // this.filters.push({"name":"Completion Date1 ","title":"Completetion Date1 ","values":[date]})      
      // console.log(this.filters)  
      // }
      if(this.index.name=="covid-19_clinical_studies"){
      // if($("#startDate").val()!=""){
      //   var startdate=new Date($("#startDate").val());
      //   var date=this.datePipe.transform(startdate, 'yyyy-MM-dd');
      //   this.filters.push({"name":"startDate","title":"startDate","values":[date]})
      // }
      // if($("#CompletionDate").val()!=""){
      //   var startdate=new Date($("#CompletionDate").val());
      //   var date=this.datePipe.transform(startdate, 'yyyy-MM-dd');
      //   this.filters.push({"name":"CompletionDate","title":"CompletionDate","values":[date]})
      // }
      }
      this.elastic.getHits(keywords, this.index, this.currentPage, this.pageSize, this.myForm.value.radio, this.fields, this.filters,this.advancesearch,this.sortvalue).subscribe((data: any) => {                      
        this.facets = []; 
        this.hits = data.hits.hits;
        this.spinnerService.hide();
        this.hits.forEach(function (value) {
          if(value._index == "medical_records" || value._index=="claims")
          { 
          value._source.first=value._source.first.replace(/[0-9]/g, '');
          value._source.last=value._source.last.replace(/[0-9]/g, '');
          if(value._index=="medical_records")
          value._source.title=value._source.title.replace(/[0-9]/g, '');
          //console.log(value._source.first.replace(/[0-9]/g, ''));
          }
      });




        //this.pageSize=10;
        if(this.consolidatedView && this.index.name=='medical_records'){
          
          this.consolidatedhits=this.groupBy(this.hits,(c) => c._source.patients_id)      
           
          this.hits=Object.values(this.consolidatedhits)

          
            for(let item of this.hits){
              var person=item[0]._source.first+" "+item[0]._source.last;
              var covered=item[0]._source.amount_covered==null?0:item[0]._source.amount_covered; //.filter(x=>x._source.amount_covered!=null).reduce((sum, current) => sum + current._source.amount_covered, 0);
              var uncovered=item[0]._source.amount_uncovered==null?0:item[0]._source.amount_uncovered; //.filter(x=>x._source.amount_covered!=null).reduce((sum, current) => sum + current._source.amount_uncovered, 0)
              this.ChartData.push({ "person":person,"CoveredAmount":covered,"UnCoveredAmount":uncovered}); //use i instead of 0
          }
           // console.log(this.ChartData)
           //console.log(this.hits)
        }        
        if(this.advancesearch.length>0)
        {          
          this.suggestions =null;    
          this.isexport = true;      
        }    
        //  else
        //  {         
        //   this.suggestions = data.suggest.mytermsuggester; 
        //  }

        //view Globals
        // if(this.index.name==""){
        //   this.sourcedisplaysettings=this.viewmappings.find(x=>x.source=="resume_library")
        // }else{
        //  this.sourcedisplaysettings=this.viewmappings.find(x=>x.source==this.index.source)
        // } 
        
        this.timeTook = data.took;
        this.totalHits =(this.consolidatedView==true && this.index.name=="medical_records")?this.hits.length: data.hits.total.value;  //        
        this.hasResults = this.totalHits > 0; 
        this.isexport = keywords!="@all";                      
        for(var key in data.aggregations) {
          if(data.aggregations.hasOwnProperty(key)) {
            this.facets.push({
              name: key,
              title: this.elastic.clean(key, [".", "_"]),
              details: data.aggregations[key][key].buckets,
              selections: (data.aggregations[key][key].meta ? data.aggregations[key][key].meta.selections : [])
            });
           
          }
        }        
       console.log(this.facets)
        if(this.index.name=="capa" || this.index.name=="covid-19_clinical_studies")
        {
          var facetinfo=this.facets;
          facetinfo.forEach( (element) => {
            if(element.name!='Enrollment')
            element.details = element.details.sort(function(a, b) {
              return a.key.localeCompare(b.key);
           });
          });
          console.log(this.facets)
          //this.facets = this.facets.sort((a, b) => a.name.localeCompare(b.name));
        }
        else{
          this.facets = this.facets.sort((a, b) => a.name.localeCompare(b.name));
        }
       
       
        var sourceFacets=this.displayFacets.find(x=>x.sourcename==this.index.name)
        // if(this.index.name=="")
        //   sourceFacets=this.displayFacets.find(x=>x.sourcename=="medical_records")
        //console.log(sourceFacets)
        if(sourceFacets!=null){
          var ret = [];
        for(var i=0;i<sourceFacets.Facets.length;i++) {
          var findobj=this.facets.find(x=>x.name==sourceFacets.Facets[i].name)
              if(findobj!=null){
                  ret.push(findobj);
              }
        }
        this.facets=ret;
       }

        this.hitsFrom = ((this.currentPage -1) * this.pageSize) + 1;
        this.hitsFrom = this.hitsFrom > this.totalHits ? this.totalHits: this.hitsFrom;
        this.hitsTo = ((this.currentPage -1) * this.pageSize) + this.pageSize;
        this.hitsTo = this.hitsTo > this.totalHits ? this.totalHits: this.hitsTo; 
        
        if(this.index.name=="medical_records" || this.index.name==""){
        //////////////////////////// race chart ////////////////////////////////////////////////
        this.showChart1();        
        //////////////////////////// county chart ////////////////////////////////////////////////
        //this.showChart2();
        this.FunnelConditions();
        //this.showChart3();
        this.pyramid();
        //this.FunnelChart();
        this.EncounterBarchart();
        this.DateChart();
        }
        else if(this.index.name=="covid-19_clinical_studies"){
          this.StudiesCountryBarchart("studiesbar");
          this.StudiesBarchart("chartdiv");
          //this.StudiesBarOutside()
          //this.BellCurve()
          this.StatusChart();
          this.InterventionChart();
        }
        else if(this.index.name=="claims"){
         var claimsGroupBy=this.groupBy(this.hits,(c) => c._source.CRG)      
           this.CRGhits=Object.values(claimsGroupBy)
           
            for(let crgdata of this.CRGhits){
              var crg=crgdata[0]._source.CRG;
              var Professional=crgdata.filter(x=>x._source.Paid_Amount_Professional!=null).reduce((sum, current) => sum + Math.round( current._source.Paid_Amount_Professional), 0);
              var Institutional=crgdata.filter(x=>x._source.Paid_Amount_Institutional!=null).reduce((sum, current) => sum +Math.round( current._source.Paid_Amount_Institutional), 0);
              
              this.CRGData.push({ "CRG":crg,"Professional":Professional,"Institutional":Institutional}); //use i instead of 0

            }
           claimsGroupBy=this.groupBy(this.hits,(c) => c._id)      
           this.Claimhits=Object.values(claimsGroupBy)
           for(let crgdata of this.Claimhits){
            var name=crgdata[0]._source.first+""+crgdata[0]._source.last;
            var Professional=crgdata.filter(x=>x._source.Paid_Amount_Professional!=null).reduce((sum, current) => sum + current._source.Paid_Amount_Professional, 0);
            var Institutional=crgdata.filter(x=>x._source.Paid_Amount_Institutional!=null).reduce((sum, current) => sum + current._source.Paid_Amount_Institutional, 0);
            
            this.ClaimsChartData.push({ "person":name,"Professional":Professional,"Institutional":Institutional}); //use i instead of 0

          }
            
          this.CRGLayeredChart();
        }
        else{
          let chart = am4core.create("chartdiv", am4charts.XYChart);
        chart.paddingRight = 20;
        chart.data = this.facets.find(x=> x.name == 'Audit_Location_Name' || x.name == 'file.extension' || x.name =='company')!=null?this.facets.find(x=> x.name == 'Audit_Location_Name' || x.name == 'file.extension' || x.name =='company').details:null;        
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "key";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "doc_count";
        series.dataFields.categoryX = "key";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();

        this.chart = chart;

        }
        
      },
      error => {
        console.log(error);
        this.error = error.message;
        if(error.error && error.error.error && error.error.error.caused_by && error.error.error.caused_by.reason)
          this.error = error.error.error.reason ? error.error.error.reason: error.error.error.caused_by.reason;
        this.hits = [];
        this.totalHits = 0;
        this.hasResults = false;
        this.hitsFrom = 0;
        this.hitsTo = 0;
      },
    )
  }
  numbersort(items){
   var sorteddata=  items.sort((a, b) => {
      if(a.doc_count > b.doc_count) {
        return -1;
      } else if(a.doc_count < b.doc_count) {
        return 1;
      } else {
        return 0;
      }
    });
return sorteddata;
}

  onFilterOptionClick(isChecked: any,filterName: string, filterTitle: string, filterOption: string): void{
    console.log(filterName +" "+filterTitle+" "+filterOption)
    if(isChecked){
      if(this.filters.filter(x => x.name === filterName).length == 0){
        this.filters.push({ "name": filterName, "title": filterTitle, "values": [] });
      }

      if(this.filters.find(x => x.name === filterName).values.indexOf(filterOption) === -1){
        this.filters.find(x => x.name === filterName).values.push(filterOption);
      }

      if(this.q=="")
      {
        this.getHits("@all");
      }
      else
      {
        this.getHits(this.q);
      }   
    }
    else {
      this.onClearFileredValue(filterName, filterOption);
    }   
  } 

  onClearFileredValue(name: string, value: string): void {
    var filter = this.filters.find(x => x.name === name);
    filter.values = filter.values.filter(v => v !== value);
    this.filters = this.filters.filter(x => x.name !== name);
    if(filter.values.length > 0){
      this.filters.push(filter);
    }
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }   
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }   
  }

  onClearFilters(): void{
    this.filters = [];
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }   
  }

  onSearchChange(keywords: string) {
    this.currentPage = 1;
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }   
  }

  onAdvanceSearchChange(keywords: string): void {    
    //console.log(this.myadvancesearch);      
    //this.advancesearch=[];
    //this.advancesearch.pop();
    //this.advancesearch.length = 0;
    while (this.advancesearch.length != 0) {
      this.advancesearch.pop();
    }     
     if(this.allwords!=""){
      this.advancesearch.push({name:'allwords',value:this.allwords});
    }
    if(this.exactphrase!=""){
      this.advancesearch.push({name:'exactphrase',value:this.exactphrase});
    }
    if(this.anywords!=""){
      this.advancesearch.push({name:'anywords',value:this.anywords});
    }
    if(this.nonewords!=""){
      this.advancesearch.push({name:'nonewords',value:this.nonewords});
    } 

    if(this.myadvancesearch.get('advanceradio').value!="")
    {
      this.advancesearch.push({name:'advanceradio',value:this.myadvancesearch.get('advanceradio').value});            
      if(this.myadvancesearch.get('advanceradio').value=="inthelastno")
      {
        this.advancesearch.push({name:'lastno',value:this.myadvancesearch.get('lastno').value});
        this.advancesearch.push({name:'daysyear',value:this.myadvancesearch.get('daysyear').value});
      }
      else if(this.myadvancesearch.get('advanceradio').value=="between"){
        this.advancesearch.push({name:'betweenfrom',value:this.myadvancesearch.get('betweenfrom').value});
        this.advancesearch.push({name:'betweento',value:this.myadvancesearch.get('betweento').value});
      }      
    }

    if(this.advancesearch.length===0)
    {      
      if(this.q=="")
      {
        this.getHits("@all");
      }
      else
      {
        this.getHits(this.q);
      }   
    }
    else{     
      this.getHits(keywords);
    }
        
    this.isadvancesearch=true;
    this.currentPage = 1;  
        
  }

  onPageSizeChange(): void {
    this.currentPage = 1;   
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }
  }

  onSuggestSelection(query): void{
    this.q = query;
    this.getHits(this.q);
  }

  onSortOrderChange(): void {
    this.currentPage = 1;
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }   
  }

  selectOption(index: any): void {
    this.hasResults=false;
    this.index = index;
    this.filters = [];
    this.fnSortlist();
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }    
  }

  capture():void{
    // this.item={};
    // this.item ["filters"] = this.filters;
    // this.item ["Keyword"] = this.q;
    //console.log(this.item);
    
    this.facetsservice.insertQryHistory(this.filters,this.q,sessionStorage.getItem('loggedinname'));
    
  }
  
  

  exportAsXLSX():void{
    if(this.q=="")
    {
      this.searchValue="@all";
    }
    else
    {
      this.searchValue=this.q;     
    }   
    this.elastic.getHits(this.searchValue, this.index, this.currentPage, this.totalHits, this.myForm.value.radio, this.fields, this.filters,this.advancesearch,this.sortvalue).subscribe((exportdata: any) => {       
      this.excel_data= exportdata.hits.hits;                     
      this.hits_export=this.excel_data.map(obj => obj._source);           
      this._excelService.exportAsExcelFile(this.hits_export, 'Intuceo-Search');                                                     
    },
    error => {
          this.hits_export= null;
          console.log(error);          
          this.error = error.message;         
    }
    );               
  }
  checkContainsFacet(key:string){
    var keys=this.facetmapings.map(function(a) {return a.name;});
     return keys.includes(key)
  }
  FacetMappingValue(key:string){    
    var keys=this.facetmapings.map(function(a) {return a.name;});
     if(keys.includes(key))
        return this.facetmapings.find(x=>x.name==key).value
  }
  openQuickView(hit: any, showProperties: boolean) {
   
    let fields = this.indices.find(x => x.name === this.index.name).fields; //Object.keys(hit._source);
    let props: Array<any> = [];       
    for(let f of fields){
      if(f.name !== "content") props.push({ name: f.name, type: f.type, value: hit._source[f.name]})
    }
    
      var conolidateddata=null;
   
      const initialState = {      
        title: (hit._source.file ? hit._source.file.filename : ((hit._source.profile_link != undefined) ? hit._source.profile_link:hit._source.title)),
        properties: props,
        clickSource:hit._index,
        content:this.index.name=='medical_records'?this.consolidatedView==true? conolidateddata:hit._source:this.__fieldsAsArray_xls(hit._source,null),
        showProperties: showProperties
      };
       
    this.modalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.setClass('modal-lg');
  }

  openConsolidatedQuickView(hit: any, showProperties: boolean) {
      
      var temp=hit; //Object.values(this.consolidatedhits)[0]
      const conolidateddata ={ 
        source:temp,
        medications:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.medications_start === thing._source.medications_start && t._source.medications_desc === thing._source.medications_desc) === i),
        allergies:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.allergies_start === thing._source.allergies_start && t._source.allergies_desc === thing._source.allergies_desc ) === i),  
        conditions:temp.filter(
        (thing, i, arr) => arr.findIndex(t => t._source.conditions_start === thing._source.conditions_start && t._source.conditions_desc === thing._source.conditions_desc) === i),
        careplans:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.careplans_start === thing._source.careplans_start && t._source.careplans_description === thing._source.careplans_description ) === i),
        procedures:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.procedures_date === thing._source.procedures_date && t._source.procedures_desc === thing._source.procedures_desc) === i),
        immunizations:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.immunizations_date === thing._source.immunizations_date && t._source.immunizations_description === thing._source.immunizations_description) === i),
        encounters:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.encounters_start === thing._source.encounters_start && t._source.encounters_desc === thing._source.encounters_desc) === i),
        studies:temp.filter(
              (thing, i, arr) => arr.findIndex(t => t._source.imaging_studies_date === thing._source.imaging_studies_date_start) === i)

          };
      //console.log(conolidateddata)
      const initialState = {      
        title: (hit[0]._source.file ? hit[0]._source.file.filename : ((hit[0]._source.profile_link != undefined) ? hit[0]._source.profile_link:hit[0]._source.title)),
        clickSource:hit._index,
        content: conolidateddata,
        showProperties: showProperties
      };
   // }
    //const initialState = {
    //  title: hit._source.file ? hit._source.file.filename : hit._id,
    //  properties: props,
    //  content: hit._source.content,
    //  showProperties: showProperties
    //};    
    this.modalRef = this.modalService.show(ConsolidatedModalContentComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.setClass('modal-lg');
  }
  openScrollableContent(longContent) {
    this.modalRef = this.modalService.show(longContent);
   
  }

  search(id:any){
    this.modalRef.hide();
    this.facetsservice.fetchById(id).subscribe((data) =>  {    
    this.filters=JSON.parse(data.filters);
    this.q=data.keyword;
    this.getHits(data.keyword);
      
    });
  }
  isreadonly_last :boolean=true;
  isbetween:boolean=true ;
  

  fnAnytime()
  {
    this.isreadonly_last=true;
    this.isbetween=true;
    this.myadvancesearch.get('daysyear').disable();
  }
  fnInlast()
  {   
    this.isreadonly_last=false;
    this.isbetween=true;
    this.myadvancesearch.get('daysyear').enable();
  }
  fnbetween()
  {
    this.isreadonly_last=true;
    this.isbetween=false;
    this.myadvancesearch.get('daysyear').disable();
  }

  fnSortlist()
  {    
    this.sorting=[];
    if(this.index.name=="medical_records"){
    this.sorting.push({ name: 'Score', values: '_score' });
    this.sorting.push({ name: 'Condition Desc', values: 'conditions_desc' });
    this.sorting.push({ name: 'County', values: 'county' }); 
    // this.sorting.push({ name: 'Name', values: 'first.keyword' });         
    }
    else
    {
      this.sorting.push({ name: 'Score', values: '_score' });
    }
  }

  selectSortlist(selected:any):void{  
    this.sortvalue=selected.values;
    this.sortname=selected.name;
    if(this.q=="")
    {
      this.getHits("@all");
    }
    else
    {
      this.getHits(this.q);
    }  
    
  }
  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  } 
 
  openPDFConfirmation(hit){
    if(this.consolidatedView){
    var temp=hit; //Object.values(this.consolidatedhits)[0]
      this.content ={ 
        source:temp,
        medications:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.medications_start === thing._source.medications_start && t._source.medications_desc === thing._source.medications_desc) === i),
        allergies:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.allergies_start === thing._source.allergies_start && t._source.allergies_desc === thing._source.allergies_desc ) === i),  
        conditions:temp.filter(
        (thing, i, arr) => arr.findIndex(t => t._source.conditions_start === thing._source.conditions_start && t._source.conditions_desc === thing._source.conditions_desc) === i),
        careplans:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.careplans_start === thing._source.careplans_start && t._source.careplans_description === thing._source.careplans_description ) === i),
        procedures:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.procedures_date === thing._source.procedures_date && t._source.procedures_desc === thing._source.procedures_desc) === i),
        immunizations:temp.filter(
          (thing, i, arr) => arr.findIndex(t => t._source.immunizations_date === thing._source.immunizations_date && t._source.immunizations_description === thing._source.immunizations_description) === i),
        encounters:temp.filter(
            (thing, i, arr) => arr.findIndex(t => t._source.encounters_start === thing._source.encounters_start && t._source.encounters_desc === thing._source.encounters_desc) === i),
        studies:temp.filter(
              (thing, i, arr) => arr.findIndex(t => t._source.imaging_studies_date === thing._source.imaging_studies_date_start) === i)

          };
           
        this.title=(hit[0]._source.file ? hit[0]._source.file.filename : ((hit[0]._source.profile_link != undefined) ? hit[0]._source.profile_link:hit[0]._source.title));
    } 
    else{
      this.detailedViewContent=hit._source;
      this.title=hit._source.file ? hit._source.file.filename : ((hit._source.profile_link != undefined) ? hit._source.profile_link:hit._source.title);
    }
    $("#pdfpopup").modal()
  }
  exporttoPDF()
  {
  
  var name=this.title;
  var pdf = new jsPDF('p', 'pt', 'letter');
    var source=null; 
    if(this.consolidatedView) 
    {
     
      if($("#Conditions").text()=="Conditions")
        $("#Conditions").remove();
      if($("#Medications").text()=="Medications")
        $("#Medications").remove();
      if($("#careplans").text()=="Care Plans")
        $("#careplans").remove();
      if($("#Allergies").text()=="Allergies")
        $("#Allergies").remove();
      if($("#Observations").text()=="Observations")
        $("#Observations").remove();
      if($("#Procedures").text()=="Procedures")
        $("#Procedures").remove(); 
       
      if($("#Immunizations").text()=="Immunizations")
        $("#Immunizations").remove();
      if($("#Encounters").text()=="Encounters")
        $("#Encounters").remove();     
      if($("#Studies").text()=="Imaging Studies")
        $("#Studies").remove();
      source = $('#PDFdiv')[0];
     // $('#PDFdiv').css("display","none");
    }
    else
    {
      source=$("#detailedPDFdiv")[0];  
     // $('#detailedPDFdiv').css("display","none");
    }
      var specialElementHandlers = {
          '#bypassme': function (element, renderer) {
              return true
          }
      };
      var margins = {
          top: 30,
          bottom: 30,
          left: 30,
          width: 1000
      };
      pdf.fromHTML(
      source, // HTML string or DOM elem ref.
      margins.left, // x coord
      margins.top, { // y coord
          'width': margins.width, // max width of content on PDF
          'elementHandlers': specialElementHandlers
      },

      function (dispose) {
          pdf.save(name);
      }, margins)

      $("#pdfpopup").modal('hide')
  }

  change()
 {​​​​
    //var elem = document.getElementById("Button");
    //if (elem.value=="Show Tutorial") elem.value = "Hide Tutorial";
    //else elem.value = "Show Tutorial";
    var x = document.getElementById("tutorial");
    if (x.style.display === "none") {​​​​
    x.style.display = "block";
    }​​​​ else {​​​​
    x.style.display = "none";
    }​​​​
 }​​​​
  
}


/* This is a component which we pass in modal*/
 
@Component({
  selector: 'modal-content',
  templateUrl:'./search.quickview.html',
  styleUrls: ['./search.component.css'],  
})

export class ModalContentComponent implements OnInit {
  title: string;
  clickSource:string
  closeBtnName: string;
  content: string;
  properties: Array<any> = [];
  showProperties: boolean;
 
  constructor(public modalRef: BsModalRef) {}
 
  ngOnInit() {
    
  }
  captureScreen()
    {
    
    var name=$('#detailedTitle').html();
    var pdf = new jsPDF('p', 'pt', 'letter');
        // source can be HTML-formatted string, or a reference
        // to an actual DOM element from which the text will be scraped.
        var source = $('#detailedPDFdiv')[0];

        // we support special element handlers. Register them with jQuery-style 
        // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
        // There is no support for any other type of selectors 
        // (class, of compound) at this time.
        var specialElementHandlers = {
            // element with id of "bypass" - jQuery style selector
            '#bypassme': function (element, renderer) {
                // true = "handled elsewhere, bypass text extraction"
                return true
            }
        };
        var margins = {
            top: 30,
            bottom: 30,
            left: 30,
            width: 1000
        };
        // all coords and widths are in jsPDF instance's declared units
        // 'inches' in this case
        pdf.fromHTML(
        source, // HTML string or DOM elem ref.
        margins.left, // x coord
        margins.top, { // y coord
            'width': margins.width, // max width of content on PDF
            'elementHandlers': specialElementHandlers
        },

        function (dispose) {
            // dispose: object with X, Y of the last line add to the PDF 
            //          this allow the insertion of new lines after html
            pdf.save(name);
        }, margins)
    }
}

  @Component({
    selector: 'modal-content',
    templateUrl:'./search.consolidatedview.html',
    styleUrls: ['./search.component.css'],  
  })
  
  export class ConsolidatedModalContentComponent implements OnInit {
    title: string;
    clickSource:string
    closeBtnName: string;
    content: string;
    properties: Array<any> = [];
    showProperties: boolean;
   
    constructor(public modalRef: BsModalRef) {}
   
    ngOnInit() {
      
    }
     captureScreen()
    {
      
      if($("#Conditions").text()=="Conditions")
        $("#PDFConditions").remove();
      if($("#Medications").text()=="Medications")
        $("#PDFMedications").remove();
      if($("#careplans").text()=="Care Plans")
        $("#PDFcareplans").remove();
      if($("#Allergies").text()=="Allergies")
        $("#PDFAllergies").remove();
      if($("#Observations").text()=="Observations")
        $("#PDFObservations").remove();
      if($("#Procedures").text()=="Procedures")
        $("#PDFProcedures").remove(); 
       
      if($("#Immunizations").text()=="Immunizations")
        $("#PDFImmunizations").remove();
      if($("#Encounters").text()=="Encounters")
        $("#PDFEncounters").remove();     
      if($("#Studies").text()=="Imaging Studies")
        $("#PDFStudies").remove();    
    var name=$('#consTitle').html();
    var pdf = new jsPDF('p', 'pt', 'letter');
        // source can be HTML-formatted string, or a reference
        // to an actual DOM element from which the text will be scraped.
        var source = $('#consolidatedPDFdiv')[0];

        // we support special element handlers. Register them with jQuery-style 
        // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
        // There is no support for any other type of selectors 
        // (class, of compound) at this time.
        var specialElementHandlers = {
            // element with id of "bypass" - jQuery style selector
            '#bypassme': function (element, renderer) {
                // true = "handled elsewhere, bypass text extraction"
                return true
            }
        };
        var margins = {
            top: 30,
            bottom: 30,
            left: 30,
            width:1000
        };
        // all coords and widths are in jsPDF instance's declared units
        // 'inches' in this case
        pdf.fromHTML(
        source, // HTML string or DOM elem ref.
        margins.left, // x coord
        margins.top, { // y coord
            'width': margins.width, // max width of content on PDF
            'elementHandlers': specialElementHandlers
        },

        function (dispose) {
            // dispose: object with X, Y of the last line add to the PDF 
            //          this allow the insertion of new lines after html
            pdf.save(name);
        }, margins)
    }

}